import { Component } from '@angular/core';
// Directive for scroll animations
import { ScrollAnimateDirective } from '../../directives/scroll-animate.directive';

@Component({
  selector: 'app-testimonials',
  imports: [ScrollAnimateDirective],
  templateUrl: './testimonials.html',
  styleUrl: './testimonials.scss',
})
export class Testimonials {
  // Array of testimonial data with customer feedback
  testimonials = [
    {
      id: 1,
      name: 'Chris Current',
      position: 'CEO of Agent First',
      avatar: '👨',
      avatarImg: '/avatars/man1.jpg',
      title: 'Exceptional quality.',
      text: 'We were genuinely impressed with the level of craftsmanship and attention to detail. The team handled our timber floor installation professionally and kept us updated throughout the process. Quick, reliable and excellent to deal with.',
    },
    {
      id: 2,
      name: 'Emma Martinez',
      position: 'Interior Designer',
      avatar: '👩',
      avatarImg: '/avatars/woman1.png',
      title: 'Brilliant service.',
      text: 'Our old timber floors look brand-new after sanding and coating. The team worked dust-free, fast and with great care. They responded quickly to every question and made the whole experience smooth and stress-free.',
    },
    {
      id: 3,
      name: 'David Kim',
      position: 'Property Manager',
      avatar: '👨‍💼',
      avatarImg: '/avatars/man2.jpg',
      title: 'Perfect colour match.',
      text: 'The floor colouring was done to an outstanding standard. They helped us choose the right shade and matched it perfectly to our interior. Great communication and a very professional finish.',
    },
    {
      id: 4,
      name: 'Sophie Anderson',
      position: 'Homeowner',
      avatar: '👩‍🦰',
      avatarImg: '/avatars/woman2.jpg',
      title: 'Amazing natural finish.',
      text: 'Their oil finishing service completely transformed our home. The natural texture of the wood looks incredible, and the team explained everything clearly. Efficient, friendly and highly skilled — couldn\'t be happier.',
    },
  ];
}
